import React from 'react';
import { Grid, GridRow, GridColumn, List } from 'semantic-ui-react';
import { useSelector } from 'react-redux';

import {
    FertilizerEntityIds,
    FertilizerEventProduct,
    FertilizerProductPerUnitType
} from 'services/fertilizerEvents/types';
import { AppState } from 'services/types';
import { ProductId } from 'services/products/types';
import { makeSelectFertilizerProductValue } from 'services/fertilizerProducts/selectors';
import FertilizerEventProductTotalListItem from '../../../FertilizerEventProductListItems/components/FertilizerEventProductTotalListItem';
import FertilizerEventTotalAreaListItem from '../../../FertilizerEventProductListItems/components/FertilizerEventTotalAreaListItem';
import FertilizerEventTotalTreesListItem from '../../../FertilizerEventProductListItems/components/FertilizerEventTotalTreesListItem';
import FertilizerEventOrderIntoTankListItem from '../../../FertilizerEventProductListItems/components/FertilizerEventOrderIntoTankListItem';
import FertilizerEventWithholdingPeriodListItem from '../../../FertilizerEventProductListItems/components/FertilizerEventWithholdingPeriodListItem';
import FertilizerEventReEntryPeriodListItem from '../../../FertilizerEventProductListItems/components/FertilizerEventReEntryPeriodListItem';

export interface Props {
    product: FertilizerEventProduct;
    productId: ProductId;
    entityIds: FertilizerEntityIds;
    orderIntoTank: number;
    perUnitType: FertilizerProductPerUnitType;
}

export default function FertilizerEventProductDetails(
    props: Props
): React.ReactElement | null {
    const { product, productId, orderIntoTank, entityIds, perUnitType } = props;

    const unitTypeId = useSelector((state: AppState) =>
        makeSelectFertilizerProductValue('unitTypeId')(state, props)
    );

    return (
        <List className="product-details">
            <Grid>
                <GridRow>
                    <GridColumn mobile={8} tablet={4} computer={4}>
                        <FertilizerEventProductTotalListItem
                            productId={productId}
                            product={product}
                            entityIds={entityIds}
                            unitTypeId={unitTypeId}
                            perUnitType={perUnitType}
                        />
                    </GridColumn>
                    <GridColumn mobile={8} tablet={4} computer={4}>
                        <FertilizerEventTotalAreaListItem
                            productId={productId}
                            entityIds={entityIds}
                        />
                    </GridColumn>
                    <GridColumn mobile={8} tablet={4} computer={4}>
                        <FertilizerEventTotalTreesListItem
                            productId={productId}
                            entityIds={entityIds}
                        />
                    </GridColumn>
                    <GridColumn mobile={8} tablet={4} computer={4}>
                        <FertilizerEventOrderIntoTankListItem
                            orderIntoTank={orderIntoTank}
                        />
                    </GridColumn>
                </GridRow>
                <GridRow>
                    <GridColumn mobile={8} tablet={4} computer={4}>
                        <FertilizerEventWithholdingPeriodListItem
                            productId={productId}
                        />
                    </GridColumn>
                    <GridColumn mobile={8} tablet={4} computer={4}>
                        <FertilizerEventReEntryPeriodListItem
                            productId={productId}
                        />
                    </GridColumn>
                </GridRow>
            </Grid>
        </List>
    );
}
